/**
 * Bedrijfsuren en agenda-dagbereik:
 * - Zelfde begin en eind → volle dag 00:00–24:00
 * - Eind 00:00 met begin ≠ 00:00 → eind 24:00 (sluiting middernacht die kalenderdag)
 * Eind 24:00 = 1440 min in timeToMinutes.
 */
export function normalizeBusinessDayTimes (start: string, end: string): { start: string; end: string } {
  const s = start.trim()
  const e = end.trim()
  if (s === e) return { start: '00:00', end: '24:00' }
  if (e === '00:00' && s !== '00:00') return { start: s, end: '24:00' }
  return { start: s, end: e }
}
